import { Typography } from '@forethought-technologies/forethought-elements';
import type { SxProps, Theme } from '@mui/material';
import { Box, styled, useTheme } from '@mui/material';
import type React from 'react';

interface TimestampProps {
  containerSx?: SxProps<Theme>;
  name?: string;
  timestamp?: number;
}

function toMilliseconds(timestamp: number) {
  // If timestamp looks like seconds, multiply by 1000
  if (timestamp < 1e12) {
    return timestamp * 1000;
  }
  // Otherwise, assume it's already milliseconds
  return timestamp;
}

export const Timestamp: React.FC<TimestampProps> = ({
  containerSx = {},
  name,
  timestamp,
}) => {
  const theme = useTheme();

  if (!timestamp) {
    return null;
  }

  const formattedTime = new Intl.DateTimeFormat(undefined, {
    timeStyle: 'short',
  }).format(toMilliseconds(timestamp));

  return (
    <Box
      sx={{ alignItems: 'center', display: 'flex', gap: '4px', ...containerSx }}
    >
      {name && (
        <>
          <Typography color={theme.palette.colors.grey[600]} variant='font11'>
            {name}
          </Typography>
          <Dot />
        </>
      )}
      <Typography color={theme.palette.colors.grey[600]} variant='font11'>
        {formattedTime}
      </Typography>
    </Box>
  );
};

const Dot = styled('div')`
  height: 2px;
  width: 2px;
  border-radius: 50%;
  background-color: ${props => props.theme.palette.colors.grey[600]};
`;
